// src/components/GAListener.jsx
// SPA 라우트 전환 시 GA4 page_view 발사. App 루트에 한 번만 마운트.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView, setGAInternal } from '../utils/ga4.js';
import { useAuth } from '../hooks/useAuth.js';

const ADMIN_EMAILS = (import.meta.env.VITE_ADMIN_EMAILS || '')
  .split(',')
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

export default function GAListener() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    initGA();
  }, []);

  // admin 으로 로그인하면 본인 트래픽을 GA4 집계에서 분리. 일반 사용자면 다시 포함.
  // (로그아웃 상태에서는 직전 판정을 유지 — 소유자 브라우저가 계속 제외되도록)
  useEffect(() => {
    if (!user?.email) return;
    setGAInternal(ADMIN_EMAILS.includes(user.email.toLowerCase()));
  }, [user]);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
